import { gql } from '@apollo/client';

export default gql`
  mutation RemoveStudentFromCourseMutation(
    $courseId: String!
    $studentId: String!
  ) {
    student(courseId: $courseId, studentId: $studentId)
      @rest(
        type: "Student"
        path: "courses/{args.courseId}/students/{args.studentId}"
        method: "DELETE"
      ) {
      _id
    }
  }
`;
